import { dataHooks as createDataHooks } from '@wix/data-hooks'

export const wixStudioTemplateDataHooks = createDataHooks<{
  back: {}
  baseTemplate: {}
  sidePanel: {}
}>('wix-studio-template')
